import TextStyle from '../../../styles/text';

export const title = {
    ...TextStyle.modal_title,
    borderBottom: 0,
    display: 'block',
    cursor: 'default',
};

export const container = {
    padding: '0px 30px 30px 0px',
    borderTop: 0,
};
